import { Component, OnInit, inject } from '@angular/core';
import { of } from 'rxjs';

import { LanguageService } from '@core/language-service/language.service';

@Component({
  selector: 'app-imprint',
  templateUrl: './imprint.component.html',
  styleUrls: ['./imprint.component.scss'],
  standalone: false,
})
export class ImprintComponent implements OnInit {
  private readonly languageService = inject(LanguageService);

  public lang = of('en');

  ngOnInit(): void {
    this.lang = this.languageService.currentLanguage$;
  }
}
